import { inject, Pipe, PipeTransform } from "@angular/core";
import { ColorService } from "src/app/services/color.service";

@Pipe({
  name: "colorById",
  standalone: false
})
export class ColorByIdPipe implements PipeTransform {
  private readonly colorService = inject(ColorService);

  transform(id: string): string {
    return this.colorService.getOrDefault(id);
  }
}
